import { createContext, useContext, useMemo, useState } from 'react'
import './ActionModal.css'

const ActionModalContext = createContext(null)

export function ActionModalProvider({ children }) {
    const [modal, setModal] = useState(null)

    const value = useMemo(() => ({
        open: (config) => {
            const next = typeof config === 'string' ? { title: config } : config
            setModal({
                title: next?.title || 'Action queued',
                description: next?.description || 'We will guide you through the next step from here.',
            })
        },
    }), [])

    return (
        <ActionModalContext.Provider value={value}>
            {children}
            {modal && (
                <div className="action-modal-backdrop" role="dialog" aria-modal="true">
                    <div className="action-modal">
                        <div className="action-modal-header">
                            <h3>{modal.title}</h3>
                            <button className="action-modal-close" onClick={() => setModal(null)} type="button">
                                ✕
                            </button>
                        </div>
                        <p>{modal.description}</p>
                        <div className="action-modal-actions">
                            <button className="btn btn-primary btn-sm" onClick={() => setModal(null)} type="button">
                                Got it
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </ActionModalContext.Provider>
    )
}

export function useActionModal() {
    const context = useContext(ActionModalContext)
    return context || { open: (message) => window.alert(typeof message === 'string' ? message : message?.title || 'Action queued') }
}
